import React from 'react';
import Buttons from '../Common/Buttons';
import { useLocale } from '../../localization/LocaleContext';
import './FreelancersPage.css';

/* ── Inline SVG icons matching the design (FontAwesome equivalents) ── */
const featureIcons = [
    // fa-file-invoice-dollar
    <svg width="20" height="20" viewBox="0 0 384 512" fill="currentColor">
        <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11.1 11.3 19.6s-11.1 13.6-19.6 11.3c-11.1-3-22-4.7-32.4-4.7c-11.3 0-18 2.8-20.3 4.5c-1.6 1.2-2.1 2.3-2.1 4.6c0 1.9 .8 3.3 2.6 4.6c3.6 2.6 9.6 4.6 18.4 6.6l.7 .1c15.2 3.4 34.3 7.6 47.7 18.3c8.4 6.7 13.7 16.5 13.7 28.6c0 15.7-8.9 28.2-21.4 35.4c-6.2 3.6-13.3 5.9-20.6 7.2V400c0 8.8-7.2 16-16 16s-16-7.2-16-16v-17.3c-9.6-1.4-18.9-3.6-27.2-6.1c-8.4-2.6-13.1-11.5-10.5-19.9s11.5-13.1 19.9-10.5c11.6 3.6 23.4 5.8 34.4 5.8c12.6 0 20.1-3.1 22.9-5.1c1.4-1 1.9-2 1.9-3.9c0-1.6-.6-2.9-2.2-4.1c-3.2-2.4-8.8-4.2-17.2-6.1l-.7-.1c-15.4-3.4-34.6-7.7-48.1-18.5c-8.6-6.9-14-16.9-14-29.1c0-15.4 8.5-27.7 20.6-34.9c6.1-3.6 13.1-5.9 20.4-7.2V232c0-8.8 7.2-16 16-16z"/>
    </svg>,
    // fa-chart-pie
    <svg width="20" height="20" viewBox="0 0 576 512" fill="currentColor">
        <path d="M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.3V220l-6 0C169.3 220 96 293.3 96 384c0 55.2 22.3 105.2 58.4 141.6c-6.7 1.6-13.7 2.4-20.9 2.4C59.6 528 0 468.4 0 395.1C0 353.4 19.1 316.2 48.9 291.9C38.9 285.4 32 274.4 32 272zM256 512c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128z"/>
    </svg>,
    // fa-credit-card
    <svg width="20" height="20" viewBox="0 0 576 512" fill="currentColor">
        <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/>
    </svg>,
];

function Features(){
    const { t } = useLocale();

    const features = [
        { id: 1, icon: featureIcons[0], title: t('freelancers.sectionOneTitle'), description: t('freelancers.sectionOneDescription') },
        { id: 2, icon: featureIcons[1], title: t('freelancers.sectionTwoTitle'), description: t('freelancers.sectionTwoDescription') },
        { id: 3, icon: featureIcons[2], title: t('freelancers.sectionThreeTitle'), description: t('freelancers.sectionThreeDescription') },
    ];

    return(
        <>
            {/* Features */}
            <section className="freelancer-features sp-90">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <h2 className="freelancer-features-heading">
                                {t('freelancers.featuresTitleStart')}{' '}{t('freelancers.featuresTitleEnd')}
                            </h2>
                            <p className="freelancer-features-subtext">
                                {t('freelancers.introOne')}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {features.map(f => (
                            <div className="col-lg-4" key={f.id}>
                                <div className="freelancer-feature-card">
                                    <div className="freelancer-feature-icon">{f.icon}</div>
                                    <h3 className="freelancer-feature-title">{f.title}</h3>
                                    <p className="freelancer-feature-desc">{f.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="freelancer-cta-green sp-90">
                <div className="container">
                    <h2 className="freelancer-cta-title">
                        {t('freelancers.ctaTitle')}
                    </h2>
                    <p className="freelancer-cta-description">
                        {t('freelancers.ctaDescription')}
                    </p>
                    <Buttons />
                </div>
            </section>
        </>
    );
}

export default Features;